const options = {
  chart: {
    type: "bar",
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    toolbar: {
      show: false
    }
  },
  grid: {
    yaxis: {
      lines: {
        show: true
      }
    },
    xaxis: {
      lines: {
        show: true
      }
    },
    padding: {
      top: -5,
      left: 10,
      right: 10,
      bottom: 0
    }
  },
  noData: {
    text: "Carregando... aguarde",
    align: "center",
    verticalAlign: "middle",
    style: {
      fontSize: "14px"
    }
  },
  plotOptions: {
    bar: {
      columnWidth: "90%",
      dataLabels: {
        position: "top",
        orientation: "vertical"
      }
    }
  },
  stroke: {
    show: true,
    width: 2,
    colors: ["transparent"]
  },
  title: {
    position: "top",
    text: "Análise Anual",
    offsetY: 7,
    offsetX: 10,
    style: {
      fontSize: "15px",
      fontWeight: "bold",
      fontFamily: "Arial",
      color: "#222"
    }
  },
  labels: [],
  dataLabels: {
    offsetY: 4,
    style: {
      fontSize: "11px",
      fontWeight: 0,
      colors: ["#000"]
    },
    formatter: function (val) {
      return formatter(val);
    }
  },
  tooltip: {
    shared: true,
    intersect: false,
    x: {
      formatter: valor => {
        if (typeof valor != "string") return valor;

        const dt = valor.split("/");
        return `${meses[parseInt(dt[0]) - 1]} de ${dt[1]}`;
      }
    },
    y: {
      formatter: valor => {
        return formatarValor(valor);
      }
    }
  },
  yaxis: {},
  xaxis: {
    labels: {
      style: {
        fontSize: "11px",
        cssClass: "apexcharts-xaxis-label"
      }
    }
  }
};

const meses = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro"
];

function formatter(n, casasDecimais = 2) {
  var ranges = [
    { divider: 1e15, suffix: "P" },
    { divider: 1e12, suffix: "T" },
    { divider: 1e9, suffix: "G" },
    { divider: 1e6, suffix: "M" },
    { divider: 1e3, suffix: "k" },
    { divider: 1, suffix: " " }
  ];

  for (var i = 0; i < ranges.length; i++) {
    if (n >= ranges[i].divider) {
      if (ranges[i].divider === 1) {
        return (
          (Math.round(n) / ranges[i].divider).toString() + ranges[i].suffix
        );
      } else {
        return (
          (Math.round(n) / ranges[i].divider)
            .toFixed(casasDecimais)
            .toString() + ranges[i].suffix
        );
      }
    }
  }
  return 0;
}

function formatarValor(val) {
  return new Intl.NumberFormat("pt-BR", {
    style: "decimal",
    maxDigits: 4,
    minimumFractionDigits: 4
  }).format(val);
}

export { options };
